import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=ad722c22&scoped=true&lang=html"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad722c22",
  null
  
)

export default component.exports